import withEntity from '@/entity/components/with-entity';

import ProtectedDetails from './protected-details';

export default withEntity(ProtectedDetails);
